<template>
    <div class="el-main-content">
        <el-row style="width: 100%">
            <el-col :lg="8" :xl="6">
                <div
                    class="el-form-card"
                    style="width: 390px !important"
                    v-loading="isLoading"
                    :element-loading-text="$t('message.other.loading')"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <div
                        style="
                            padding: 10px 10px 5px 30px;
                            background-color: #323c49;
                        "
                    >
                        <el-row>
                            <el-col
                                :span="12"
                                style="
                                    color: #ffffff;
                                    font-weight: bold;
                                    font-size: 16px;
                                "
                            >
                                {{
                                    readonly
                                        ? 'Booking Information'
                                        : `${formText} ${$t(
                                              'form.title.booking'
                                          )}`
                                }}
                            </el-col>
                            <el-col :span="12">
                                <div style="color: #33c8b3; font-weight: bold">
                                    {{ $t('form.label.generatedPINCode') }}
                                </div>
                                <div style="color: #ffffff; font-weight: bold">
                                    {{ this.form.pinCode }}
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div
                        class="el-form-card__body"
                        style="padding: 0; margin-top: 20px"
                    >
                        <el-form
                            ref="form"
                            class="dark-form"
                            label-position="top"
                            label-width="150px"
                            size="mini"
                            :model="form"
                            :rules="rules"
                        >
                            <el-row
                                v-if="selectedContainer.ContainerType === 'CCC'"
                            >
                                <div class="el-form-card__element-wrapper">
                                    <el-form-item prop="container">
                                        <treeselect
                                            v-model="form.container"
                                            value-format="object"
                                            class="custom-container-tree-select"
                                            @select="containerSelect"
                                            :flat="true"
                                            :clearable="false"
                                            :placeholder="
                                                $t(
                                                    'form.label.selectRecipientDestination'
                                                )
                                            "
                                            :options="selectedContainerTree"
                                            :normalizer="normalizer"
                                            required
                                        />
                                    </el-form-item>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <v-radio-group v-model="isUserMode" row>
                                        <v-icon style="color: #c9cbcf"
                                            >person</v-icon
                                        >
                                        <v-radio
                                            :label="$t('form.title.user')"
                                            value="user"
                                            color="primary"
                                        ></v-radio>
                                        <v-icon style="color: #c9cbcf"
                                            >people</v-icon
                                        >
                                        <v-radio
                                            :label="$t('form.title.userGroup')"
                                            value="userGroup"
                                            color="primary"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                            </el-row>

                            <div v-show="isUserMode === 'user'">
                                <el-row>
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item
                                            v-if="
                                                permissions.includes(
                                                    'USER_READ'
                                                )
                                            "
                                            prop="recipient"
                                        >
                                            <v-select
                                                :items="recipients"
                                                :readonly="readonly"
                                                item-text="Label"
                                                combobox
                                                return-object
                                                v-model="form.recipient"
                                                :label="
                                                    $t(
                                                        'form.label.recipientName'
                                                    )
                                                "
                                                dark
                                                :clearable="!readonly"
                                                required
                                                prepend-icon="person_search"
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </div>
                                </el-row>
                            </div>

                            <div v-show="isUserMode === 'userGroup'">
                                <el-row>
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item prop="userGroup">
                                            <v-select
                                                :items="userGroups"
                                                :readonly="readonly"
                                                item-text="GroupName"
                                                item-value="UserGroupID"
                                                return-object
                                                v-model="form.userGroup"
                                                :label="
                                                    $t('form.title.userGroup')
                                                "
                                                dark
                                                :clearable="!readonly"
                                                required
                                                combobox
                                                prepend-icon="person_search"
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </div>
                                </el-row>
                            </div>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="3">
                                        <img
                                            style="
                                                width: 24px;
                                                margin-top: 25px;
                                            "
                                            src="/images/icon/ua.png"
                                        />
                                    </el-col>
                                    <el-col :span="21">
                                        <el-form-item prop="unloadingArea">
                                            <v-select
                                                :items="activeUnloadingAreas"
                                                :readonly="readonly"
                                                item-text="ShortDescription"
                                                item-value="UnloadingAreaID"
                                                return-object
                                                v-model="form.unloadingArea"
                                                :label="
                                                    $t(
                                                        'form.label.unloadingArea'
                                                    )
                                                "
                                                dark
                                                :clearable="!readonly"
                                                combobox
                                                required
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-row>

                            <hr class="divider" />

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-form-item prop="supplier">
                                        <v-select
                                            class="custom-supplier-dropdown"
                                            :items="suppliers"
                                            :readonly="readonly"
                                            item-text="SupplierName"
                                            item-value="SupplierID"
                                            return-object
                                            combobox
                                            v-model="form.supplier"
                                            :label="
                                                $t('form.label.selectSupplier')
                                            "
                                            dark
                                            solo
                                            :clearable="!readonly"
                                            required
                                        >
                                        </v-select>
                                    </el-form-item>
                                </div>
                            </el-row>

                            <el-row>
                                <div
                                    class="el-form-card__element-wrapper"
                                    style="margin-top: 10px"
                                >
                                    <el-col :span="24">
                                        <div
                                            style="
                                                color: #33c8b3;
                                                font-size: 12px;
                                            "
                                        >
                                            <span>{{
                                                $t('form.label.arrivalTime')
                                            }}</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <v-icon style="color: #c9cbcf"
                                            >schedule</v-icon
                                        >
                                    </el-col>
                                    <el-col :span="14">
                                        <el-date-picker
                                            id="actualArrival"
                                            v-model="form.actualArrival"
                                            type="datetime"
                                            format="yyyy-MM-dd HH:mm"
                                            :placeholder="
                                                $t('form.label.arrival')
                                            "
                                            :picker-options="pickerOptions"
                                            :readonly="readonly"
                                            class="
                                                el-date-picker-dark
                                                el-date-picker-dark--lg
                                            "
                                        >
                                        </el-date-picker>
                                    </el-col>
                                    <el-col :span="4">
                                        <v-btn
                                            class="
                                                el-table-info__btn
                                                el-btn-with-input
                                                el-table-info__btn--dark
                                            "
                                            flat
                                            @click="setArrival"
                                        >
                                            {{ $t('button.text.now') }}
                                        </v-btn>
                                    </el-col>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="3">
                                        <img
                                            style="
                                                width: 24px;
                                                margin-top: 25px;
                                            "
                                            src="/images/icon/wa.png"
                                        />
                                    </el-col>
                                    <el-col :span="21">
                                        <el-form-item prop="waitingArea">
                                            <v-select
                                                :items="waitingAreas"
                                                :readonly="readonly"
                                                item-text="Description"
                                                item-value="WaitingAreaID"
                                                return-object
                                                v-model="form.waitingArea"
                                                :label="
                                                    $t('form.label.waitingArea')
                                                "
                                                dark
                                                :clearable="!readonly"
                                                required
                                                combobox
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="23">
                                        <el-form-item prop="driverPhoneNo">
                                            <v-text-field
                                                :readonly="readonly"
                                                :label="
                                                    $t(
                                                        'form.label.driverPhoneNo'
                                                    )
                                                "
                                                v-model="form.driverPhoneNo"
                                                prepend-icon="phone"
                                                required
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="1">
                                        <v-tooltip right>
                                            <v-icon
                                                style="
                                                    color: rgb(52, 200, 180);
                                                    font-size: 20px;
                                                    margin-top: 20px;
                                                    cursor: pointer;
                                                "
                                                right
                                                slot="activator"
                                            >
                                                info
                                            </v-icon>
                                            <span
                                                v-html="
                                                    $t(
                                                        'form.helpText.phoneNumber'
                                                    )
                                                "
                                            />
                                        </v-tooltip>
                                    </el-col>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="3">
                                        <img
                                            style="
                                                width: 32px;
                                                margin-top: 25px;
                                            "
                                            src="/images/icon/anpr.png"
                                        />
                                    </el-col>
                                    <el-col :span="20">
                                        <el-form-item prop="plateNo">
                                            <v-text-field
                                                :readonly="readonly"
                                                :label="
                                                    $t(
                                                        'form.label.vehicleNumberPlate'
                                                    )
                                                "
                                                v-model="form.plateNo"
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="1">
                                        <v-tooltip right>
                                            <v-icon
                                                style="
                                                    color: rgb(52, 200, 180);
                                                    font-size: 20px;
                                                    margin-top: 20px;
                                                    cursor: pointer;
                                                "
                                                right
                                                slot="activator"
                                            >
                                                info
                                            </v-icon>
                                            <span
                                                v-html="
                                                    $t(
                                                        'form.helpText.vehicleNumber'
                                                    )
                                                "
                                            />
                                        </v-tooltip>
                                    </el-col>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="12">
                                        <el-form-item prop="driverFirstName">
                                            <v-text-field
                                                :readonly="readonly"
                                                :label="
                                                    $t(
                                                        'form.label.driverFirstName'
                                                    )
                                                "
                                                v-model="form.driverFirstName"
                                                prepend-icon="contact_mail"
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item prop="driverLastName">
                                            <v-text-field
                                                :readonly="readonly"
                                                :label="
                                                    $t(
                                                        'form.label.driverLastName'
                                                    )
                                                "
                                                v-model="form.driverLastName"
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-row>

                            <hr class="divider" />

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <v-select
                                        :items="checkpointAccessSchedules"
                                        :label="
                                            $t(
                                                'form.label.checkpointAccessSchedule'
                                            )
                                        "
                                        item-text="Description"
                                        item-value="ScheduleTemplateID"
                                        class="input-bg-light"
                                        v-model="form.DefaultCpAccessSchedule"
                                    >
                                    </v-select>
                                </div>
                            </el-row>

                            <el-row>
                                <div class="el-form-card__element-wrapper">
                                    <el-form-item prop="comment">
                                        <v-text-field
                                            :label="
                                                $t(
                                                    'form.label.additionalInformation'
                                                )
                                            "
                                            :readonly="readonly"
                                            v-model="form.comment"
                                            multi-line
                                            prepend-icon="info"
                                        />
                                    </el-form-item>
                                </div>
                            </el-row>
                            <div
                                class="
                                    button-wrapper
                                    flex
                                    justify-between
                                    items-center
                                "
                                v-if="!isMilkRun"
                            >
                                <v-btn
                                    round
                                    color="primary"
                                    @click="submit"
                                    :disabled="
                                        !showSubmitButton ||
                                        loading ||
                                        (form.container &&
                                            form.container.ContainerType ===
                                                'CCC')
                                    "
                                    dark
                                >
                                    {{ formText }}
                                </v-btn>
                                <v-btn round color="dark" dark>
                                    {{ $t('form.button.cancel') }}
                                </v-btn>
                            </div>
                            <el-row v-if="!showSubmitButton">
                                <div class="el-form-card__element-wrapper">
                                    <div style="margin-bottom: 20px">
                                        <v-icon
                                            style="
                                                color: rgb(242 98 35);
                                                font-size: 20px;
                                                margin-right: 5px;
                                                cursor: pointer;
                                            "
                                            right
                                            slot="activator"
                                        >
                                            info
                                        </v-icon>
                                        <span
                                            style="color: rgb(200 203 207)"
                                            v-html="
                                                $t('form.label.existingBooking')
                                            "
                                        />
                                    </div>
                                </div>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </el-col>
            <el-col :lg="16" :xl="18">
                <el-row style="width;100%">
                    <el-col :span="24">
                        <div class="el-grid-card" style="width: 100%">
                            <el-row>
                                <el-col :span="12">
                                    <div
                                        class="el-inner-table-right-col"
                                        style="margin-bottom: 10px"
                                    >
                                        <h2
                                            class="
                                                el-form-card__inner-title
                                                mb-2
                                            "
                                        >
                                            {{
                                                $t(
                                                    'form.title.unloadingResourcesRequired'
                                                )
                                            }}
                                        </h2>

                                        <div
                                            class="
                                                el-inner-table-check-box-list
                                            "
                                        >
                                            <div class="dark-form">
                                                <div class="el-radio-list">
                                                    <v-checkbox
                                                        :label="
                                                            $t(
                                                                'form.label.forkLift'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="
                                                            booking__check-box--fork-lift
                                                        "
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="FORKLIFT"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :label="
                                                            $t(
                                                                'form.label.truck'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="
                                                            booking__check-box--truck
                                                        "
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="TRUCK"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :disabled="readonly"
                                                        :label="
                                                            $t(
                                                                'form.label.labourers'
                                                            )
                                                        "
                                                        class="
                                                            booking__check-box--labourers
                                                        "
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="MANPOWER"
                                                        hide-details
                                                    >
                                                    </v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="
                                                el-inner-table-check-box-list
                                            "
                                        >
                                            <div class="dark-form">
                                                <div class="el-radio-list">
                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :disabled="readonly"
                                                        :label="
                                                            $t(
                                                                'form.label.industrialCrane'
                                                            )
                                                        "
                                                        class="
                                                            booking__check-box--crane
                                                        "
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="CRANE"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        :label="
                                                            $t(
                                                                'form.label.tools'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="
                                                            booking__check-box--tools
                                                        "
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="TOOLS"
                                                        hide-details
                                                    >
                                                    </v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <stc-file-gallery
                                        :deleteUrl="deleteUrl"
                                        :displayFiles="files"
                                        @current-selected-file-count="
                                            onCurrentSelectedFiles
                                        "
                                    ></stc-file-gallery>
                                </el-col>
                            </el-row>
                            <div
                                class="
                                    el-table__dark-expandable el-table__modal
                                "
                            >
                                <stc-booking-blc-package
                                    v-for="packageGroup in packageGroups"
                                    :key="
                                        packageGroup.PackageGroupID ||
                                        packageGroup.id
                                    "
                                    :data-blc-package="packageGroup"
                                    :actor="actor"
                                    :readonly="readonly"
                                    :suppliers="suppliers"
                                    @delete-blc-package="deletePackage"
                                >
                                </stc-booking-blc-package>

                                <div class="el-row" v-if="!isMilkRun">
                                    <div class="el-bottom-btn-panel">
                                        <v-btn
                                            class="
                                                el-table-info__btn
                                                el-table-info__btn--lg
                                                el-table-info__btn--primary
                                            "
                                            flat
                                            @click="addPackage"
                                        >
                                            {{
                                                $t(
                                                    'modal.button.addPackageGroup'
                                                )
                                            }}
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <stc-day-calendar
                            :currentActorId="actor.ActorID"
                        ></stc-day-calendar>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import StcPassword from '../Password'
import StcBookingBlcPackage from './BookingBlcPackage'
import InteractWithActor from '../../mixins/interact-with-actor'
import Treeselect from '@riophae/vue-treeselect'
import moment from 'moment'

import UnloadingAreasMixin from '../../mixins/unloading-areas-mixin'
import BlcMixin from '../../mixins/blc-mixin'
import GatesMixin from '../../mixins/gates-mixin'
import SupplierMixin from '../../mixins/supplier-mixin'
import RecipientsMixin from '../../mixins/recipients-mixin'
import SchedulesMixin from '../../mixins/schedules-mixin'
import UserGroupsMixin from '../../mixins/user-groups-mixin'
import DatesMixin from '../../mixins/interact-with-dates'
import FileGallery from './FileGallery'
import DayCalendar from './DayCalendar'
import { Constants } from '../../constants'

const MyLocInventory = () => import('./MyLocInventory')

export default {
    name: 'booking-create',

    props: {
        isEditable: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: undefined,
        },
        selectedUnloadingArea: {
            type: Object,
            default: undefined,
        },
        waitingAreas: {
            type: Array,
            default: undefined,
        },
    },

    data() {
        return {
            readonly: false,
            showAddMaterials: false,
            actor: '',
            editing: false,
            loading: false,
            preFlexes: [0, 5, 10, 15, 20, 30],
            unloadingTimes: [0, 15, 20, 25, 30, 40, 50, 60, 90, 120],
            form: {
                actorType: 'SLOT',
                container: null,
                recipient: '',
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                firstName: '',
                lastName: '',
                pinCode: '',
                plateNo: '',
                unloadingArea: null,
                supplier: null,
                inGate: '',
                outGate: '',
                gates: [],
                dateTimeRange: [],
                estimatedArrival: DateTime.local().endOf('day').toJSDate(),
                actualArrival: '',
                schedule: {
                    Description: '',
                    ScheduleParts: [
                        {
                            ValidFrom: null,
                            ValidTo: null,
                            WeekStart: 0,
                            WeekStop: 0,
                            IsSimpleSchedule: true,
                        },
                    ],
                },
                allowApp: true,
                company: '',
                phone: '',
                email: '',
                comment: '',
                maxUsageTimes: 1,
                noOfDeliveries: 1,
                preFlex: 0,
                isSendInvitationMessage: false,
                isShowGate: false,
                isAdvance: false,
                isExpressDelivery: false,
                unloadingTimeInMins: 0,
                requestedResources: [],
                waitingArea: null,
                userGroup: null,
                driverPhoneNo: '',
                ActorStatus: 0,
                WANotificationStatus: 0,
                DefaultCpAccessSchedule: '',
            },
            packageGroups: [],
            inventoryItems: [],
            orderedItems: [],
            isUserMode: 'user',
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            maxUsageTimeRule: {
                max: (v) =>
                    v < this.selectedContainer.MaximumPassingsPerBooking ||
                    this.$t('form.validation.invalidMaxUsageTimes', {
                        number: this.selectedContainer
                            .MaximumPassingsPerBooking,
                    }),
            },
            showSubmitButton: true,
            fromDate: '',
            toDate: '',
            fromTime: '00:00',
            toTime: '00:30',
            timeStepper: '00:30',
            isValidDateRange: true,
            defaultTimeStep: 15,
            deleteUrl: '',
            files: [],
            isLoading: false,
            currentSelectedFileCount: 0,
            destinationContainer: '',
            actorValidFrom: '',
            actorValidTo: '',
            checkpointAccessSchedules: [],
        }
    },

    created: async function () {
        this.reset()
        this.form.actualArrival = this.getRoundedOffDate()

        // Edit mode
        if (this.isEditable && this.data) {
            this.reset()
            this.isLoading = true

            if (this.data.Status === 0 && !this.data.RelatedActorID) {
                this.generatePassword()
            }

            this.editing = true
            this.readonly = false

            this.files = this.data.WANotificationImages
            this.deleteUrl = `/WANotification/${this.data.WANotificationID}/images/`
            this.form.isExpressDelivery = this.data.IsExpress
            if (this.data.ActualArrival) {
                // this.form.actualArrival = DateTime.fromISO(
                //     this.data.ActualArrival,
                //     { zone: 'utc' }
                // ).toJSDate()
                this.form.actualArrival = this.data.ActualArrival
            } else {
                // this.form.actualArrival = DateTime.fromISO(
                //     this.data.EstimatedArrival,
                //     { zone: 'utc' }
                // ).toJSDate()
                this.form.actualArrival = this.data.EstimatedArrival
            }
            this.form.WANotificationStatus = this.data.Status

            // Change destination container
            this.destinationContainer = await this.getContainer(
                this.data.DestinationContainerID,
                this.selectedContainerTree[0]
            )
            this.form.container = this.destinationContainer

            await this.getRecipients(this.destinationContainer)
            if (this.data.RecipientUserID) {
                this.isUserMode = 'user'
                this.form.recipient = _.find(this.recipients, {
                    UserID: this.data.RecipientUserID,
                })
            }

            await this.getUnloadingAreas(this.destinationContainer)

            // Update Day Calendar
            Events.$emit(
                'fetch-calendar-data',
                this.destinationContainer,
                this.unloadingAreas,
                null,
                this.form.actualArrival
            )

            await this.fetchSuppliers(this.destinationContainer)
            this.suppliers.forEach((supplier) => {
                if (supplier.SupplierID === this.data.SupplierId) {
                    this.form.supplier = supplier
                    return
                }
            })

            await this.fetchUserGroups(this.destinationContainer)
            if (this.data.RecipientUserGroupID) {
                this.isUserMode = 'userGroup'
                this.form.userGroup = _.find(this.userGroups, {
                    UserGroupID: this.data.RecipientUserGroupID,
                })
            }

            this.form.waitingArea = _.find(this.waitingAreas, {
                WaitingAreaID: this.data.WaitingAreaID,
            })

            // Fetch Actor
            if (this.data.RelatedActorID) {
                this.actor = await this.fetchActorByID(this.data.RelatedActorID)
                if (!this.actor) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                    return
                }

                this.fillFormActor(this.actor)

                let gates = this.actor.AccessSets.map((accessSet) =>
                    _.find(this.uniqueGates, {
                        CheckpointID: accessSet['CheckPointID'],
                    })
                )

                this.form.gates = [...gates]
                this.actor.AccessSets.forEach((accessSet) => {
                    this.fillFormAccessSet(accessSet)
                })

                this.form.isSendInvitationMessage = _.some(
                    [this.form.email, this.form.phone],
                    (val) => val && val.length
                )
                this.form.isAdvance = _.some(
                    [this.form.preFlex, this.form.unloadingTimeInMins],
                    (val) => val > 0
                )
            }

            this.$nextTick(() => {
                this.isLoading = false
                this.$forceUpdate()
            })
        } else {
            this.generatePassword()
            this.readonly = true
        }
    },
    updated() {
        if (this.selectedUnloadingArea) {
            this.form.unloadingArea = this.selectedUnloadingArea
        }
    },
    mounted() {
        if (!this.packageGroups.length) {
            this.addPackage()
        }
        this.$refs.password && this.$refs.password.generate()

        if (this.selectedContainer.ContainerType === 'CCC') {
            this.form.actorType = 'BLC'
            this.form.estimatedArrival = moment()
                .endOf('day')
                .subtract(1, 'milliseconds')
                .toDate()
        }

        Events.$on('actor-add-packages', () => {
            if (!this.packageGroups.length) {
                this.addPackage()
            }
        })

        Events.$on('generate-password', () => {
            this.$refs.password && this.$refs.password.generate()
        })

        Events.$on('actor-reset', () => {
            this.reset()
        })

        Events.$on('actor-update', (validFrom, validTo) => {
            console.log('actor-update', validFrom, validTo)
            this.actorValidFrom = validFrom
            this.actorValidTo = validTo
            this.form.actualArrival = validFrom
        })

        Events.$on('update-overlapping-status', (value) => {
            this.showSubmitButton = !value
        })
    },

    mixins: [
        InteractWithActor,
        UnloadingAreasMixin,
        BlcMixin,
        GatesMixin,
        RecipientsMixin,
        SchedulesMixin,
        SupplierMixin,
        UserGroupsMixin,
        DatesMixin,
    ],

    components: {
        'stc-my-loc-inventory': MyLocInventory,
        'stc-password': StcPassword,
        'stc-booking-blc-package': StcBookingBlcPackage,
        'stc-file-gallery': FileGallery,
        'stc-day-calendar': DayCalendar,
        treeselect: Treeselect,
    },

    watch: {
        'form.noOfDeliveries': function (noOfDeliveries) {
            if (this.form.actorType === 'PASS') {
                if (this.form.gates && this.form.gates.length > 0) {
                    this.form.maxUsageTimes =
                        noOfDeliveries * this.form.gates.length
                } else {
                    this.form.maxUsageTimes = noOfDeliveries
                }
            } else {
                if (
                    this.form.unloadingArea.MaxPassages &&
                    this.form.unloadingArea.MaxPassages > 0
                ) {
                    this.form.maxUsageTimes =
                        noOfDeliveries * this.form.unloadingArea.MaxPassages
                } else {
                    if (this.form.unloadingArea.Checkpoints) {
                        this.form.maxUsageTimes =
                            noOfDeliveries *
                            this.form.unloadingArea.Checkpoints.length
                    } else {
                        this.form.maxUsageTimes = noOfDeliveries
                    }
                }
            }
        },

        'form.unloadingArea': function (unloadingArea) {
            if (unloadingArea.MaxPassages && unloadingArea.MaxPassages > 0) {
                this.form.maxUsageTimes =
                    this.form.noOfDeliveries * unloadingArea.MaxPassages
            } else {
                if (unloadingArea.Checkpoints) {
                    this.form.maxUsageTimes =
                        this.form.noOfDeliveries *
                        unloadingArea.Checkpoints.length
                } else {
                    this.form.maxUsageTimes = this.form.noOfDeliveries
                }
            }
            this.$nextTick(() => {
                this.updateDayCalendar()
            })
        },

        'form.gates': function (gates) {
            if (this.form.actorType === 'PASS') {
                if (gates && gates.length > 0) {
                    this.form.maxUsageTimes =
                        this.form.noOfDeliveries * gates.length
                } else {
                    this.form.maxUsageTimes = this.form.noOfDeliveries
                }
            }
        },

        'form.actualArrival': _.debounce(function (actualArrival) {
            this.form.actualArrival = this.getRoundedOffDate(actualArrival)
            this.updateDayCalendar()
        }, 1000),

        'form.isAdvance': function (isAdvance) {
            if (!isAdvance) {
                this.form.preFlex = 0
                this.form.maxUsageTimes = 1
                this.form.unloadingTimeInMins = 0
            }
        },

        'form.recipient': function (recipient) {
            if (_.isObject(recipient)) {
                this.form.recipientName =
                    recipient.FirstName + ' ' + recipient.LastName
                this.form.recipientCompany = recipient.Company
                this.form.recipientPhone = recipient.Phone
            } else {
                this.form.recipientName = recipient
            }
        },
    },

    computed: {
        ...mapGetters(['permissions', 'selectedContainer']),

        selectedContainerTree() {
            return [this.selectedContainer]
        },

        unloadingAreaCheckpoints() {
            if (!this.form.unloadingArea) return []

            return this.form.unloadingArea.Checkpoints.map((id) => {
                return _.find(this.gates, { CheckpointID: id })
            })
        },

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },

        actorPayload() {
            let form = _.cloneDeep(this.form)

            let accessSets = []

            accessSets = this.buildAccessSetWithoutGates(form)

            accessSets.forEach((set) => {
                set.DestinationContainerID = this.form.container.ContainerID
                if (this.isUserMode === 'userGroup') {
                    set.RecipientCompany = null
                    set.RecipientName = null
                    set.RecipientPhone = null
                }
            })

            return {
                ActorType: 'TENTATIVE',
                Email: this.form.email,
                FirstName: this.form.driverFirstName,
                LastName: this.form.driverLastName,
                MAIsEnabled: this.form.allowApp,
                Comment: this.form.comment,
                PinCode: this.form.pinCode,
                PlateNo: this.form.plateNo,
                Phone: this.form.driverPhoneNo,
                Company: this.form.supplier
                    ? this.form.supplier.SupplierName
                    : null,
                LocationValidationDisabled: true,
                MaxUsageTimes: this.form.maxUsageTimes,
                NoOfDeliveries: this.form.noOfDeliveries,
                UnloadingTimeInMins: this.form.unloadingTimeInMins,
                AccessSets: accessSets,
                PackageGroups: this.packageGroups,
                Status: this.form.ActorStatus,
            }
        },

        waNotificationPayload() {
            return {
                DestinationContainerID: this.form.container.ContainerID,
                ActualArrival: this.form.actualArrival,
                // ActualArrival: moment(this.form.actualArrival),
                // .utc()
                // .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                EstimatedArrival: null,
                UnloadingAreaID: this.form.unloadingArea
                    ? this.form.unloadingArea.UnloadingAreaID
                    : null,
                Instructions: this.form.comment,
                WaitingAreaID: this.form.waitingArea
                    ? this.form.waitingArea.WaitingAreaID
                    : null,
                RecipientUserID:
                    this.isUserMode === 'user'
                        ? this.form.recipient.UserID
                        : null,
                RecipientUserGroupID:
                    this.isUserMode === 'userGroup' && this.form.userGroup
                        ? this.form.userGroup.UserGroupID
                        : null,
                SupplierID: this.form.supplier
                    ? this.form.supplier.SupplierID
                    : null,
                Images: [],
                RelatedActorID: '',
                IsExpress: this.form.isExpressDelivery,
                Status: this.form.WANotificationStatus,
            }
        },

        isBlc() {
            return this.form.actorType == 'BLC'
        },

        isStock() {
            return this.form.actorType == 'stock'
        },

        isMilkRun() {
            return this.form.actorType == 'MILKRUN'
        },

        hasPackageItems() {
            return (
                this.packageGroups.length > 0 &&
                _.every(this.packageGroups, (group) => {
                    return group.PackageItems.length > 0
                })
            )
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        rules() {
            const rules = {
                actorType: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.slot'),
                        }),
                        trigger: 'blur',
                    },
                ],
                pinCode: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.pinCodeForDriver'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: this.$t('form.validation.minNumberDigits', {
                            name: this.$t('form.label.pinCodeForDriver'),
                            number: 6,
                        }),
                        trigger: 'blur,change',
                    },
                ],
                recipient: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t(
                            'form.validation.selectRequiredOrEnter',
                            {
                                name: this.$t('form.label.recipientName'),
                            }
                        ),
                        trigger: 'blur',
                    },
                ],
                recipientCompany: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.recipientCompany'),
                        }),
                        trigger: 'blur',
                    },
                ],
                recipientPhone: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.recipientPhone'),
                        }),
                        trigger: 'blur',
                    },
                ],
                userGroup: [
                    {
                        required: this.isUserMode === 'userGroup',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.title.userGroup'),
                        }),
                        trigger: 'blur',
                    },
                ],
                supplier: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.supplierName'),
                        }),
                        trigger: 'blur',
                    },
                ],
                unloadingArea: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.unloadingArea'),
                        }),
                        trigger: 'blur',
                    },
                ],
                inGate: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: this.$t('form.label.entranceGate'),
                        }),
                        trigger: 'blur',
                    },
                ],
                outGate: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: this.$t('form.label.exitGate'),
                        }),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        type: 'email',
                        message: this.$t('form.validation.valid', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur,change',
                    },
                ],
                driverPhoneNo: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.driverPhoneNo'),
                        }),
                        trigger: 'blur',
                    },
                ],
                waitingArea: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.waitingArea'),
                        }),
                        trigger: 'blur',
                    },
                ],
                estimatedArrival: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: 'date',
                        }),
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },
    },

    methods: {
        async setArrival(e) {
            this.form.actualArrival = this.getRoundedOffDate()
        },

        reset() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }

            this.actor = ''
            this.form.supplier = null
            this.form.actorType = 'SLOT'
            this.form.pinCode = ''
            this.form.unloadingArea = ''
            this.form.phone = ''
            this.form.email = ''
            this.form.isExpressDelivery = false
            this.form.requestedResources = []
            this.form.gates = []
            this.packageGroups = []
            this.orderedItems = []
            this.editing = false
            this.readonly = false
            this.isUserMode = 'user'
            this.form.recipient = null
            this.form.unloadingArea = null
        },

        async containerSelect(container) {
            Events.$emit('fetch-calendar-data', null)
            this.reset()

            if (
                container.ContainerType !== 'CCC' &&
                container.AvailableBookingTypes.includes('WA')
            ) {
                this.readonly = false
                this.destinationContainer = container
                this.form.supplier = null
                this.$nextTick(() => {
                    this.generatePassword()
                    this.isLoading = true
                })
                this.getRecipients(container)
                this.fetchSuppliers(container)
                this.fetchUserGroups(container)
                await this.getUnloadingAreas(container)

                await this.updateDayCalendar()

                this.isLoading = false

                const checkpointAccessScheduleResponse = await this.$http.get(
                    `/Container/${container.ContainerID}/ScheduleTemplate`
                )
                this.checkpointAccessSchedules =
                    checkpointAccessScheduleResponse.data

                // Set default checkpoint Access Schedules
                console.log(this.checkpointAccessSchedules)
                if (container.DefaultCpAccessSchedule) {
                    this.form.DefaultCpAccessSchedule =
                        this.checkpointAccessSchedules.filter(
                            (it) =>
                                it.ScheduleTemplateID ==
                                container.DefaultCpAccessSchedule
                        )[0]
                }
            } else {
                this.$message({
                    type: 'warning',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.warning.invalidSelection',
                        {
                            selection:
                                this.$i18n.i18next.t(
                                    'table.column.destination'
                                ) +
                                ' ' +
                                this.$i18n.i18next.t('form.label.container'),
                        }
                    ),
                })
            }
        },

        onCurrentSelectedFiles(count) {
            this.currentSelectedFileCount = count
        },

        async submit() {
            this.loading = true

            try {
                // Validate form
                await this.$refs.form.validate()

                let actor = _.cloneDeep(this.actorPayload)

                let accessSet = actor.AccessSets[0]
                const accessSets = this.form.waitingArea.Checkpoints.map(
                    (checkpointId) => ({
                        ...accessSet,
                        CheckPointID: checkpointId,
                        ScheduleTemplates: [
                            this.form.DefaultCpAccessSchedule
                                .ScheduleTemplateID,
                        ],
                    })
                )
                actor.AccessSets = accessSets

                // Set ValidFrom and ValidTo values
                actor.AccessSets.forEach((accessSet) => {
                    accessSet.Schedules.forEach((schedule) => {
                        schedule.ScheduleParts.forEach((part) => {
                            part.ValidFrom = this.actorValidFrom
                            part.ValidTo = this.actorValidTo
                        })
                    })
                })

                let method
                let url
                if (
                    this.data &&
                    this.data.Status === 0 &&
                    !this.data.RelatedActorID
                ) {
                    method = 'post'
                    url = 'Actor'
                } else {
                    method = this.editing ? 'put' : 'post'
                    url = this.editing ? `Actor/${this.actor.ActorID}` : 'Actor'
                }

                // Create/Update Actor
                const actorResponse = await this.$http[method](url, actor)

                if (!actorResponse || (!this.editing && !actorResponse.data)) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                    return
                }

                // Post WA Notification
                let blcContainerID = this.selectedContainer.ContainerID

                if (!blcContainerID) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.noBLC'),
                    })

                    this.loading = false

                    return
                }

                if (this.editing) {
                    this.waNotificationPayload.WANotificationID =
                        this.data.WANotificationID
                    this.waNotificationPayload.RelatedActorID =
                        actorResponse && actorResponse.data
                            ? actorResponse.data
                            : this.data.RelatedActorID
                    await this.$http.put(
                        `/WANotification/${this.data.WANotificationID}`,
                        this.waNotificationPayload
                    )
                    Events.$emit(
                        'upload-files',
                        `/WANotification/${this.data.WANotificationID}/images`
                    )
                } else {
                    this.waNotificationPayload.RelatedActorID =
                        actorResponse.data
                    const waNotificationResponse = await this.$http.post(
                        `/WANotification`,
                        this.waNotificationPayload
                    )

                    // Upload images, Delete Images
                    if (
                        !waNotificationResponse ||
                        !waNotificationResponse.data
                    ) {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                        return
                    }
                    Events.$emit(
                        'upload-files',
                        `/WANotification/${waNotificationResponse.data}/images`
                    )
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.booking'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.booking'),
                          }),
                })

                if (this.currentSelectedFileCount === 0) {
                    // Events.$emit('date-range-changed') // This will be called via socket event.
                    this.closeView()
                }
                // If new files are available to upload, then it will be handled via Events.$on('upload-files-success') once files are uploaded.
            } catch (e) {
                console.error(e)
                if (e === false || e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${
                            e.response.data.Message || e.response.data
                        }.`,
                    })
                }
            }

            this.loading = false
        },

        fillFormActor(actor) {
            this.form.allowApp = actor.MAIsEnabled
            this.form.actorType = actor.ActorType || ''
            this.form.driverFirstName = actor.FirstName || ''
            this.form.driverLastName = actor.LastName || ''
            this.form.driverPhoneNo = actor.Phone || ''
            this.form.company = actor.Company || ''
            this.form.email = actor.Email || ''
            this.form.pinCode = actor.PinCode || ''
            this.form.plateNo = actor.PlateNo || ''
            this.form.maxUsageTimes = actor.MaxUsageTimes || 1
            this.form.noOfDeliveries = actor.NoOfDeliveries || 1
            this.form.comment = actor.Comment || ''
            this.form.unloadingTimeInMins = actor.UnloadingTimeInMins || 0
            this.form.ActorStatus = actor.Status
            this.packageGroups = actor.PackageGroups
            if (
                actor.AccessSets &&
                actor.AccessSets[0].Schedules &&
                actor.AccessSets[0].Schedules.length > 0 &&
                actor.AccessSets[0].Schedules[0].ScheduleParts
            ) {
                this.actorValidFrom = DateTime.fromISO(
                    actor.AccessSets[0].Schedules[0].ScheduleParts[0].ValidFrom
                ).toFormat(this.dateTimeFormat)

                this.actorValidTo = DateTime.fromISO(
                    actor.AccessSets[0].Schedules[0].ScheduleParts[0].ValidTo
                ).toFormat(this.dateTimeFormat)
            }
        },

        fillFormAccessSet(accessSet) {
            accessSet.Schedules.forEach((schedule) => {
                schedule.ScheduleParts.forEach((part) => {
                    let direction = part.Direction.toLowerCase()

                    this.form.unloadingArea =
                        _.find(this.activeUnloadingAreas, {
                            UnloadingAreaID: accessSet['UnloadingAreaID'],
                        }) || ''

                    this.form[`${direction}Gate`] =
                        _.find(this[`${direction}Gates`], {
                            CheckpointID: accessSet['CheckPointID'],
                        }) || ''

                    this.dateTimeRange = [
                        moment(DateTime.fromISO(part.ValidFrom).toJSDate()),
                        moment(DateTime.fromISO(part.ValidTo).toJSDate()),
                    ]

                    this.form.preFlex = part.PreFlex
                    this.form.requestedResources = _.map(
                        accessSet.RequestedResources,
                        'ResourceType'
                    )
                })
            })
        },

        addPackage() {
            this.packageGroups.push({
                id: _.uniqueId(),
                Reference: '',
                OrderNo: '',
                SupplierName: '',
                SupplierID: '',
                PackageItems: [
                    {
                        Height: 0,
                        Width: 0,
                        Length: 0,
                        Weight: 0,
                        PackageType: '',
                        Description: '',
                        TrackingReference: '',
                        CustomReference: '',
                    },
                ],
            })
        },

        async deletePackage(blcPackage) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'package',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                if (blcPackage.PackageGroupID) {
                    this.$http.delete(
                        `/Actor/${this.actor.ActorID}/PackageGroup/${blcPackage.PackageGroupID}`
                    )
                }

                let index = this.packageGroups.indexOf(blcPackage)

                this.packageGroups.splice(index, 1)
            } catch (e) {
                //
            }
        },

        getResponse() {
            if (this.form.actorType === 'BLC') {
                return [
                    DateTime.fromISO(this.form.estimatedArrival.toISOString())
                        .startOf('week')
                        .toJSDate(),
                    DateTime.fromISO(this.form.estimatedArrival.toISOString())
                        .endOf('week')
                        .toJSDate(),
                ]
            } else {
                return [
                    DateTime.fromISO(this.dateTimeRange[0].toISOString())
                        .startOf('week')
                        .toJSDate(),
                    DateTime.fromISO(this.dateTimeRange[1].toISOString())
                        .endOf('week')
                        .toJSDate(),
                ]
            }
        },

        // Recursively call the container tree and search for the requested container.
        async getContainer(containerId, currentContainer) {
            if (containerId === currentContainer.ContainerID) {
                return currentContainer
            }

            if (currentContainer.Children) {
                for (let i = 0; i < currentContainer.Children.length; i++) {
                    const res = await this.getContainer(
                        containerId,
                        currentContainer.Children[i]
                    )
                    if (res) return res
                }
            }
        },

        closeView() {
            Events.$emit('toggle-wanotification-create-view', false)
        },

        async updateDayCalendar() {
            let tempActor = this.createTemporaryActor(
                this.destinationContainer.DefaultWATime &&
                    this.destinationContainer.DefaultWATime > 0
                    ? this.destinationContainer.DefaultWATime
                    : Constants.DefaultWATime
            )
            // if (
            //     !this.isEditable ||
            //     (this.isEditable &&
            //         !this.data.RelatedActorID &&
            //         this.data.Status === 0)
            // ) {
            // tempActor = this.createTemporaryActor(
            //     this.destinationContainer.DefaultWATime &&
            //         this.destinationContainer.DefaultWATime > 0
            //         ? this.destinationContainer.DefaultWATime
            //         : Constants.DefaultWATime
            // )
            // }

            if (this.isEditable && this.data) {
            } else {
                // Update day calendar view
                Events.$emit(
                    'fetch-calendar-data',
                    this.destinationContainer,
                    this.unloadingAreas,
                    tempActor,
                    this.form.actualArrival
                )
            }
        },

        createTemporaryActor(destinationContainerWATime) {
            if (!destinationContainerWATime) destinationContainerWATime = 0

            const validFrom = moment(this.form.actualArrival)
            const validTo = validFrom
                .clone()
                .add(destinationContainerWATime, 'minutes')

            this.dateTimeRange = [validFrom, validTo]

            this.actorValidFrom = DateTime.fromISO(
                validFrom.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            this.actorValidTo = DateTime.fromISO(
                validTo.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            return {
                ActorID: 'tempTentativeActor',
                ActorType: 'PROPOSED SLOT',
                CurrentUnloadingAreaID: this.form.unloadingArea
                    ? this.form.unloadingArea.UnloadingAreaID
                    : null,
                AccessSets: [
                    {
                        UnloadingAreaID: '',
                        Schedules: [
                            {
                                ScheduleParts: [
                                    {
                                        ValidFrom: this.actorValidFrom,
                                        ValidTo: this.actorValidTo,
                                    },
                                ],
                            },
                        ],
                        ScheduleTemplates: [],
                        RequestedResources: [],
                    },
                ],
                PackageGroups: [],
            }
        },

        async generatePassword() {
            let { data } = await this.$http.get('Util/GeneratePin')
            this.form.pinCode = data
        },
    },
}
</script>
<style>
.input-group--disabled label {
    color: #989ea6 !important;
}
.input-group--disabled input {
    color: #989ea6 !important;
}

.el-date-picker-dark .el-input__inner {
    color: #989ea6 !important;
}
.divider {
    border-top: 2px solid rgb(168, 174, 182);
    margin: 20px 0px 5px 0;
}
.custom-container-tree-select {
    background: #2db4ff;
    border-radius: 25px;
    padding: 8px 20px;
}
.custom-container-tree-select .vue-treeselect__single-value {
    color: #ffffff !important;
    font-weight: bold;
}

.custom-container-tree-select .vue-treeselect__input {
    color: #ffffff !important;
    font-weight: bold;
}

.custom-container-tree-select .vue-treeselect__control {
    border-bottom: none;
}

.custom-container-tree-select .vue-treeselect__arrow {
    border-top-color: #ffffff;
}

.custom-container-tree-select .vue-treeselect__placeholder {
    color: #ffffff;
    font-weight: bold;
    text-transform: uppercase;
}

.application .theme--dark.input-group.input-group--solo,
.theme--dark .input-group.input-group--solo {
    border-radius: 25px;
}

.custom-supplier-dropdown {
    margin-top: 18px;
}

.custom-supplier-dropdown .input-group__input {
    background-color: #2db4ff !important;
    border-radius: 25px;
    padding: 10px 10px;
}
.custom-supplier-dropdown label {
    color: #ffffff !important;
    font-weight: bold !important;
    margin-top: 2px;
    text-transform: uppercase;
}

.custom-supplier-dropdown .input-group__selections__comma {
    color: #ffffff !important;
    font-weight: bold !important;
}

.custom-supplier-dropdown .icon {
    color: #ffffff !important;
    font-weight: bold !important;
}

.custom-supplier-dropdown .input-group__details {
    display: none;
}

.el-picker-panel time-select el-popper {
    z-index: 99999 !important;
}

.menu__content {
    margin-top: 0;
}

.vue-treeselect__menu {
    background: #424242;
    color: #ffffff;
    border: none;
}
</style>
